import { Testimonial } from "./types";

export const testimonials: readonly Testimonial[] = Object.freeze([
  {
    id: "alice-wonderweb",
    name: "Alice Wonderweb",
    testimonial:
      "Jolly splendid! With proper OPQUAST manners and an accessibility-first compass, launching my wee startup felt like buttering toast in the Queen’s parlour.",
  },
  {
    id: "sir-codsworth",
    name: "Sir Codsworth the Accessible",
    testimonial:
      "They said building a startup was like fighting trolls blindfolded. Rubbish! Semantic HTML and ARIA saved the day.",
  },
  {
    id: "lady-debugalot",
    name: "Lady Debugalot",
    testimonial: "Focus traps, you say? I laugh in the face of modals! No screen reader shall get lost under my watch.",
  },
  {
    id: "professor-arial",
    name: "Professor Arial Sans",
    testimonial: "Every alt tag tells a story, every button sings. Accessibility isn’t a feature; it’s the overture.",
  },
  {
    id: "the-funky-duke",
    name: "The Funky Duke of UX",
    testimonial: "I once deployed a site so accessible, even my cat could navigate it. Truly majestic.",
  },
  {
    id: "granny-grids",
    name: "Granny Grids",
    testimonial:
      "In my day, we used tables for layout. But now? Grid and flex, and every element behaves like a well-trained butler.",
  },
  {
    id: "baroness-of-buttons",
    name: "Baroness of Buttons",
    testimonial: "I don’t just style buttons—I raise them into polite, interactive citizens of the web.",
  },
  {
    id: "sir-tabs-a-lot",
    name: "Sir Tabs-a-Lot",
    testimonial:
      "My keyboard dances through the interface like Fred Astaire. Every input a partner, every skiplink a waltz.",
  },
  {
    id: "count-clickalot",
    name: "Count Clickalot",
    testimonial:
      "OPQUAST taught me not to click wildly, but with intention and joy. Also, label your icons, dear friends.",
  },
  {
    id: "lady-lighthouse",
    name: "Lady Lighthouse",
    testimonial: "My scores are so green they photosynthesise. Accessibility? Practically botanical.",
  },
  {
    id: "duchess-div",
    name: "Duchess Div",
    testimonial: "No more meaningless containers. I wield roles and landmarks like a proper aristocrat.",
  },
  {
    id: "earl-of-errors",
    name: "Earl of Errors",
    testimonial:
      "Used to fail audits like a clown in a teapot. Now? My forms whisper sweet validations to screen readers.",
  },
  {
    id: "madam-margin",
    name: "Madam Margin",
    testimonial: "With rems, ems, and a good sense of rhythm, my layouts prance across viewports like ballet dancers.",
  },
  {
    id: "lord-landmark",
    name: "Lord Landmark of Regionaria",
    testimonial:
      "No screen reader shall wander in the dark. My page is a symphony of roles, landmarks, and delightful skiplinks.",
  },
  {
    id: "captain-correctness",
    name: "Captain Correctness",
    testimonial: "Alt text? Labels? Colour contrast? Yes, yes, and oh dear yes. My app could pass a royal inspection.",
  },
  {
    id: "the-marquis-of-modals",
    name: "The Marquis of Modals",
    testimonial: "I once opened a modal so well-behaved it offered me tea before stealing focus. Bloody polite, that.",
  },
  {
    id: "mistress-meta",
    name: "Mistress Meta",
    testimonial:
      "My pages whisper sweet nothings to search engines and screen readers alike. Meta tags are love letters, really.",
  },
  {
    id: "lord-legibility",
    name: "Lord Legibility the Third",
    testimonial: "Clarity, hierarchy, elegance. My type scales like a Gregorian chant read aloud by Stephen Fry.",
  },
  {
    id: "vicar-of-validity",
    name: "Vicar of Validity",
    testimonial: "Thy code shall validate, and lo! Even the W3C did nod in solemn approval.",
  },
  {
    id: "knight-of-narration",
    name: "Knight of Narration",
    testimonial:
      "My interface is a novel. Each element a chapter, each interaction a plot twist — but no cliffhangers for screen readers!",
  },
  {
    id: "the-bold-widow",
    name: "The Bold Widow of Breakpoints",
    testimonial:
      "From the tiniest wristwatch to the grandest 8K screen, my layout adjusts like a seasoned actor taking the stage.",
  },
]);
